import React from "react";
import CampaignForm from "../CampaignForm";

const EditCampaign = () => {
  return <CampaignForm isEdit={true} />;
};

export default EditCampaign;
